
import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, Clock, MapPin, Heart, Shield, Users } from 'lucide-react';
import ServiceCard from './ServiceCard';

const Features: React.FC = () => {
  const services = [
    {
      icon: <Calendar className="h-6 w-6" />,
      title: "Home Care",
      description: "Regular assistance with personal care, mobility, and daily activities to support independence at home."
    },
    {
      icon: <Clock className="h-6 w-6" />,
      title: "Cleaning Services",
      description: "Professional home cleaning to maintain a comfortable and hygienic living environment."
    },
    {
      icon: <Heart className="h-6 w-6" />,
      title: "Companionship",
      description: "Friendly visits for social interaction, activities, and emotional support."
    },
    {
      icon: <MapPin className="h-6 w-6" />,
      title: "Grocery Shopping",
      description: "Regular shopping assistance with delivery of groceries and essentials to the doorstep."
    },
    {
      icon: <Shield className="h-6 w-6" />,
      title: "Medical Reminders",
      description: "Timely medication reminders and assistance with healthcare appointments."
    },
    {
      icon: <Users className="h-6 w-6" />,
      title: "Garden Maintenance",
      description: "Regular garden upkeep to maintain outdoor spaces in a safe and enjoyable condition."
    }
  ];

  return (
    <section className="py-20 relative overflow-hidden">
      <div className="container-custom">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <span className="inline-block py-1 px-3 rounded-full text-sm font-medium bg-care-100 text-care-800 mb-4">
              Bubblecare Services
            </span>
            <h2 className="text-3xl md:text-4xl font-bold mb-4 tracking-tight text-balance">
              Services available to your care bubble
            </h2>
            <p className="text-muted-foreground text-lg mx-auto text-balance">
              Our platform offers a wide range of professional services that can be coordinated through your care bubble, ensuring your loved ones receive comprehensive support in the comfort of their own homes.
            </p>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <ServiceCard
              key={index}
              icon={service.icon}
              title={service.title}
              description={service.description}
              delay={index}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
